var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.838,
    height: 9.627,
    viewBox: "0 0 12.838 9.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.657 47.993)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.418,40.62a2.266,2.266,0,0,0,2-2.375v-.379a2,2,0,1,0-4,0v.379A2.266,2.266,0,0,0,6.418,40.62Zm-4.008.391a1.372,1.372,0,0,0,1.2-1.284v-.642a1.2,1.2,0,1,0-2.4,0v.642a1.387,1.387,0,0,0,1.2,1.284Zm7.2,1.6a.171.171,0,0,0,0-.019,1.547,1.547,0,0,0-.044-.222,0,0,0,0,0,0,0,1.373,1.373,0,0,0-.219-.448h0a2.577,2.577,0,0,0-.861-.725.949.949,0,0,0-.463-.184c-.221,0-.414.172-.74.471h0l-.3.272c-.01.01-.33.461-.569.461s-.558-.451-.569-.461l-.3-.272h0c-.325-.3-.518-.471-.74-.471a.87.87,0,0,0-.463.184,3.015,3.015,0,0,0-.862.722h0v0a1.373,1.373,0,0,0-.217.445l0,0a1.589,1.589,0,0,0-.043.22.189.189,0,0,1,0,.02,2.224,2.224,0,0,0-.014.245v1.765c0,.57.215.8.8.8H8.826c.592,0,.8-.219.8-.8V42.859a2.257,2.257,0,0,0-.014-.243Zm.82-1.6a1.372,1.372,0,0,0,1.2-1.284v-.642a1.2,1.2,0,1,0-2.4,0v.642A1.386,1.386,0,0,0,10.434,41.011ZM.913,41.88A1.736,1.736,0,0,0,0,43.423c0,.007,0,.8,0,.8,0,.582.2.8.8.8h1.6V42.62l-.4-.4C1.581,41.845,1.224,41.7.913,41.88Zm1.494.741C2.416,42.628,2.407,42.43,2.407,42.62Zm10.43.8a1.736,1.736,0,0,0-.912-1.543c-.311-.177-.669-.035-1.093.34l-.4.4v2.407h1.606c.607,0,.8-.22.8-.8C12.838,44.219,12.837,43.43,12.837,43.423Zm-2.407-.8C10.43,42.43,10.421,42.628,10.43,42.62Z",
    transform: "translate(-8.657 -83.793)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.89dbca61.svg";
export { ForwardRef as ReactComponent };